import axios from 'axios';

export const fetchGlobalSearch = (term) => {
    return axios.get(`${process.env.VUE_APP_CORE_SPA_API_URL}/v1/search?term=${term}`);
};
